<template>
  <div class="logo customer_logo" v-if="logoImg">
    <img class="customer-logo" :src="logoImg" alt="회사 로고" width="140" height="30.5" :key="logoImg" />
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'OfficeLogo',
  computed: {
    ...mapState({
      cacheOfficeInfo: (state) => state.cache.officeInfo,
    }),
    logoImg() {
      // [MEMO]
      // 서버 데이터 로드 시간이 있어 초기에 null 리턴됨을 인지하여야함
      // 데이터가 로드되면 재실행 됨

      try {
        // [CASE1] 커스텀 로고를 사용하지 않는 경우, 로고를 보여주지 않도록 한다.
        if (!this.cacheOfficeInfo.config.is_custom_logo) {
          return null;
        }

        // [CASE2] PATH_INFO 고려 (구 오피스에 대한 대응으로 보여짐)
        // 사이드 이펙트 우려로 인해 하단 코드 유지
        if (window.PATH_INFO && window.PATH_INFO.DOMAIN) {
          let checkTargetDomain = window.PATH_INFO.URLTYPE === 'G' ? window.PATH_INFO.GROUPID : window.PATH_INFO.DOMAIN;
          let returnImgSrc = process.env.VUE_APP_OFFICE_URL + '/' + checkTargetDomain + '/common/logo';

          if (checkTargetDomain !== this.cacheOfficeInfo.office.office_id) {
            return returnImgSrc + '/' + this.cacheOfficeInfo.office.office_id;
          }

          return returnImgSrc;
        }

        // [CASE3] 오피스 커스텀 로고를 보여준다.
        return process.env.VUE_APP_OFFICE_URL + '/' + this.cacheOfficeInfo.office.office_id + '/common/logo';
      } catch (error) {
        return null;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.customer_logo {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 140px;
  height: 30.5px;
  font-size: 0;
  flex-shrink: 0;
  img {
    object-fit: contain;
    width: 140px !important;
    height: 30.5px !important;
  }
}
</style>
